// src/context/BookingContext.js
import React, { createContext, useState } from 'react';

export const BookingContext = createContext();

export const BookingProvider = ({ children }) => {
  const [selectedSpace, setSelectedSpace] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [numPlayers, setNumPlayers] = useState(8); // minimum of 8 players

  return (
    <BookingContext.Provider value={{ selectedSpace, setSelectedSpace, selectedDate, setSelectedDate, startTime, setStartTime, endTime, setEndTime, numPlayers, setNumPlayers }}>
      {children}
    </BookingContext.Provider>
  );
};
